import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

import GungHeadshot from '../assets/Gung_Headshot.jpeg';

function Home({ eventDetails }) {
  const NEW_OBITUARY = `Dr. Ernest Hew passed away on December 5, 2025. He is survived by his kids, Julie, Susie (James Jin), Lucy (Ben Woo), Lisa, Janice (Ted Timar), Ben (Jacqueline Leung), and ten grandchildren: Nicholas (Natasha), Magnus, Tristan, Selene, Brayden, Leo, Henry, Noelani, Sofia and Nyla. Born in Montego Bay, Jamaica, “Old Man” attended Cornwall College (1958) where he was a football player winning the DaCosta Cup and the Olivier Shield. Studies and sports continued at medical school at the University of West Indies, Kingston, JA (1964), where he was the Jamaica champion in badminton and an exceptional tennis player. Education and work opened doors to Magdalen College, Oxford University, England (1968) as a Rhodes Scholar, and then Örnsköldsviks Sjukhus and Sahlgrenska University Hospital in Sweden. Settling down in Canada, our dad worked at Mount Sinai Hospital, taking extra weekend shifts in Thunder Bay, then at Windsor Regional Hospital, and North York General Hospital (NYGH), followed by various Toronto-based pain and endoscopy clinics. 

  The following are memories shared by our Uncle (Dr.) Kwok Lee: Another important aspect of your dad’s professional life was his input in the introduction of Lumbar Epidural for labour and delivery in Canada. I happened to have just finished my residency in Anaesthesia in 1984 at a time when Lumbar Epidural was not a standard service offered to females in labour. It was Ernie’s relentless efforts in many speaking tours in Toronto and elsewhere to introduce epidurals, plus a large series of clinical studies, that established the safety and protocol of epidurals that many women in labour now benefit from. During SARS of 2003, when NYGH was completely quarantined and turned into a SARS hospital, with the properties of SARS unknown at the time, Ernie volunteered to go back to the hospital to care for patients in the ICU. For your dad’s work in Labour Epidurals and SARS, the Anaesthesia Department in 2005 unanimously nominated him for the Dr. Peter Newman Humanitarian Award of the NYGH, and he received the award at the Medical Staff Association meeting of the year.

  Our family would like to thank everyone who assisted in our dad’s care, particularly Yvonne Sun, Sophie Wang, Jerry Sun, Edward Hew Sang, Randy Li and Graham Toomey. Our dad chose to donate his body to the Division of Anatomy at the University of Toronto. Always with a strong mind, our dad lived with determination and perseverance, deeply invested in the well-being of everyone he encountered. From his roots in Jamaica to a lifetime of service—supporting a family of six kids, training physicians and nurses in Canada and internationally, and caring for countless patients—we hope dad can now rest. 
  `;

  const NEW_OBITUARY_QUOTE = `
  “Thou know’st ’tis common
  All that lives must die,
  Passing through nature to eternity."
     — Hamlet, William Shakespeare
  `;

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-container">
          <div className="hero-image">
            <img src={GungHeadshot} alt={eventDetails?.personName || 'Dr. Ernest Hew'} />
          </div>
          <div className="hero-content">
            <p className="hero-subtitle">In Loving Memory</p>
            <h1 className="hero-title">{eventDetails?.personName || 'Dr. Ernest Hew'}</h1>
            <div className="hero-divider">
              <span className="divider-line"></span>
              <span className="divider-symbol">✦</span>
              <span className="divider-line"></span>
            </div>
            <p className="hero-tagline">Celebration of Life</p>
            <a
              href="https://drive.google.com/drive/folders/1xZu78f3CVGcmoc4k9I5MAgdKTsp2bmXv?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="hero-cta-button"
            >
              Virtual Recording &amp; Memories
            </a>
          </div>
        </div>
      </section>

      {/* Obituary Section */}
      <section className="obituary-section section">
        <div className="container">
          <div className="obituary-card">
            <h2 className="section-title">Remembering {eventDetails?.personName || 'Dr. Ernest Hew'}</h2>
            
            <div className="obituary-content">
              {NEW_OBITUARY.split('\n\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
              {NEW_OBITUARY_QUOTE.split('\n').map((paragraph, index) => (
                <p className="obituary-quote" key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Donations Section */}
      <section className="donations-section section">
        <div className="container">
          <div className="donations-card">
            <h2 className="section-title">In Lieu of Flowers</h2>
            <p className="donations-intro">
            Sharing thoughts and memories is more than enough. If you wish to make a gesture, a donation to either the Cornwall College Foundation Scholarship Fund or the University of the West Indies Medical Alumni Association (UWIMAA) Canada would be appreciated.
            </p>

            <div className="donation-options">
              {/* UWIMAA */}
              <div className="donation-option">
                <h3>UWI Medical Alumni Association (UWIMAA) Canada</h3>
                <p className="donation-description">
                  Supporting medical education and healthcare initiatives.
                </p>
                <div className="donation-methods">
                  <div className="donation-method">
                    <h4>Canada (Interac e-Transfer)</h4>
                    <p>Name: uwi1948m</p>
                    <p>Email: chris.maa@nexicom.net</p>
                  </div>
                  <div className="donation-method">
                    <h4>By Mail</h4>
                    <p>
                      UWIMAA Canadian Chapter<br />
                      P.O. Box 1201<br />
                      Lakefield, ON, K0L 2H0
                    </p>
                  </div>
                </div>
                <p className="donation-note">
                  Please include your postal address to receive a charitable receipt.
                </p>
              </div>

              {/* Cornwall College */}
              <div className="donation-option">
                <h3>Cornwall College Foundation</h3>
                <p className="donation-description">
                  All funds will be used for Cornwall College, with a project to be determined with input from the family in honour of Dr. Ernest Hew's memory.
                </p>
                <div className="donation-methods">
                  <div className="donation-method">
                    <h4>International</h4>
                    <p>
                      <a href="https://www.cornwallcollegefoundation.org" target="_blank" rel="noopener noreferrer">
                        www.cornwallcollegefoundation.org
                      </a>
                    </p>
                  </div>
                  <div className="donation-method">
                    <h4>Canada</h4>
                    <ul>
                      <li>e-Transfer to: ccaatreasurer1@hotmail.com</li>
                      <li>Online: <a href="http://www.ccaacanada.ca" target="_blank" rel="noopener noreferrer">www.ccaacanada.ca</a></li>
                      <li>
                        Mail cheque to:<br />
                        Treasurer Hearon Anderson<br />
                        1134 Hickory Hollow Glen<br />
                        Mississauga, ON, L5W 1Z8
                      </li>
                    </ul>
                  </div>
                  <div className="donation-method">
                    <h4>USA</h4>
                    <ul>
                      <li>Zelle to: (954) 817-6427</li>
                      <li>
                        Mail cheque to:<br />
                        Cornwall College Foundation<br />
                        2817 SW 83rd Ave<br />
                        Miramar, Florida, 33025
                      </li>
                    </ul>
                  </div>
                </div>
                <p className="donation-note">
                  <strong>Important:</strong> Please note that the donation is for Dr. Ernest Hew.<br />
                  Tax receipts are issued for donations in Canada and the USA.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Condolences CTA */}
      <section className="condolences-cta-section section">
        <div className="container">
          <div className="condolences-cta">
            <h2 className="section-title">Memories & Condolences</h2>
            <p className="cta-text">
              Read messages left by others below.
            </p>
            <Link to="/condolences" className="calendar-button">
              View Condolences
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
